export enum ImageName {
    acceptTender = "acceptTender",
    actions = "actions",
    activateSlideout = "activateSlideout",
    activeCircle = "activeCircle",
    activeMonitorUpdate = "activeMonitorUpdate",
    add = "add",
    addCash = "addCash",
    addDriver = "addDriver",
    addInBox = "addInBox",
    addNotes = "addNotes",
    addRecovery = "addRecovery",
    addTable = "addTable",
    adjustRates = "adjustRates",
    alarm = "alarm",
    apiDot = "apiDot",
    apiGear = "apiGear",
    applicationControl = "applicationControl",
    appointmentConfirmed = "appointmentConfirmed",
    appointmentRequired = "appointmentRequired",
    arrow = "arrow",
    arrowDown = "arrowDown",
    arrowSplit = "arrowSplit",
    arrowUp = "arrowUp",
    ascending = "ascending",
    asterisk = "asterisk",
    autoMatch = "autoMatch",
    balanceDue = "balanceDue",
    bol = "bol",
    boxPalletFacingRight = "boxPalletFacingRight",
    bridgeCustomer = "bridgeCustomer",
    bridgeCustomerTurned = "bridgeCustomerTurned",
    brokenPallet = "brokenPallet",
    brokerageBadge = "brokerageBadge",
    browser = "browser",
    bullseye = "bullseye",
    bulkUpdate = "bulkUpdate",
    bypassBatch = "bypassBatch",
    calculator = "calculator",
    calendar = "calendar",
    calendarSchedule = "calendarSchedule",
    callConversion = "callConversion",
    callRecord = "callRecord",
    cancel = "cancel",
    carrier = "carrier",
    carrierCapacity = "carrierCapacity",
    carrierRates = "carrierRates",
    carrierRemove = "carrierRemove",
    carrierSearch = "carrierSearch",
    cautionBadge = "cautionBadge",
    cellPhone = "cellPhone",
    change = "change",
    chartLine = "chartLine",
    chatEmpty = "chatEmpty",
    chatImportant = "chatImportant",
    chatLines = "chatLines",
    chatPerson = "chatPerson",
    check = "check",
    checkboxChecked = "checkboxChecked",
    checkboxIndeterminate = "checkboxIndeterminate",
    checkboxUnchecked = "checkboxUnchecked",
    chevron = "chevron",
    circleCheck = "circleCheck",
    circleCheckEmpty = "circleCheckEmpty",
    circleEmpty = "circleEmpty",
    circleError = "circleError",
    circleErrorSolid = "circleErrorSolid",
    circleFilled = "circleFilled",
    circlePlusFilled = "circlePlusFilled",
    circleQuestion = "circleQuestion",
    circleX = "circleX",
    classicMode = "classicMode",
    clipboard = "clipboard",
    clipboardXs = "clipboardXs",
    clock = "clock",
    cloud = "cloud",
    cloudFilled = "cloudFilled",
    codeTags = "codeTags",
    commissionsOverrideRate = "commissionsOverrideRate",
    connect = "connect",
    convertQuote = "convertQuote",
    copy = "copy",
    crossDock = "crossDock",
    cross_ref_confirmed = "cross_ref_confirmed",
    cross_ref_missing = "cross_ref_missing",
    curlyBrackets = "curlyBrackets",
    dash = "dash",
    datafusionCustomer = "datafusionCustomer",
    datLogo = "datLogo",
    declineTender = "declineTender",
    deductionEarningRecord = "deductionEarningRecord",
    defaultMonitorUpdate = "defaultMonitorUpdate",
    delete = "delete",
    delivery = "delivery",
    deliveryReceipt = "deliveryReceipt",
    descending = "descending",
    detention = "detention",
    detentionFree = "detentionFree",
    detentionCharging = "detentionCharging",
    detentionOccurred = "detentionOccurred",
    detentionClosed = "detentionClosed",
    dfNoReplyNeedsAtt = "dfNoReplyNeedsAtt",
    dfNoReplyTransError = "dfNoReplyTransError",
    dfPartner = "dfPartner",
    dfReplyErrorNeedsAtt = "dfReplyErrorNeedsAtt",
    dfReplyErrorTransError = "dfReplyErrorTransError",
    dfReplyGoodNeedsAtt = "dfReplyGoodNeedsAtt",
    dfReplyGoodTransError = "dfReplyGoodTransError",
    digitalOffer = "digitalOffer",
    designer_attachment = "designer/attachment",
    designer_button = "designer/button",
    designer_chart = "designer/chart",
    designer_checkbox = "designer/checkbox",
    designer_citystate = "designer/citystate",
    designer_dataheader = "designer/dataheader",
    designer_daterange = "designer/daterange",
    designer_datasource = "designer/datasource",
    designer_gaugechart = "designer/gaugechart",
    designer_horizontalspacer = "designer/horizontalspacer",
    designer_iframe = "designer/iframe",
    designer_image = "designer/image",
    designer_innerJoin = "designer/innerJoin",
    designer_label = "designer/label",
    designer_layout = "designer/layout",
    designer_layoutheader = "designer/layoutheader",
    designer_map = "designer/map",
    designer_numbereditor = "designer/numbereditor",
    designer_outerJoin = "designer/outerJoin",
    designer_panel = "designer/panel",
    designer_progressbar = "designer/progressbar",
    designer_radio = "designer/radio",
    designer_radiobox = "designer/radiobox",
    designer_repeater = "designer/repeater",
    designer_savebutton = "designer/savebutton",
    designer_searchbutton = "designer/searchbutton",
    designer_splitter = "designer/splitter",
    designer_starrating = "designer/starrating",
    designer_stepper = "designer/stepper",
    designer_switch = "designer/switch",
    designer_tab = "designer/tab",
    designer_table = "designer/table",
    designer_tabset = "designer/tabset",
    designer_textbox = "designer/textbox",
    designer_tree = "designer/tree",
    designer_widget = "designer/widget",
    detail = "detail",
    dfReplyError = "dfReplyError",
    disk = "disk",
    diskX = "diskX",
    document = "document",
    documentException = "documentException",
    documentUpload = "documentUpload",
    doubleChevron = "doubleChevron",
    download = "download",
    driverAssign = "driverAssign",
    driverMsgErrors = "driverMsgErrors",
    driverMsgNormal = "driverMsgNormal",
    driverMsgUnread = "driverMsgUnread",
    drivers = "drivers",
    driverSmsOptedOut = "driverSmsOptedOut",
    dryVanLeftFacing = "dryVanLeftFacing",
    dryVanWithArrowRight = "dryVanWithArrowRight",
    duplicateDisk = "duplicateDisk",
    ellipsis = "ellipsis",
    emptyMove = "emptyMove",
    emailStatusUnknown = "emailStatusUnknown",
    emailUnverified = "emailUnverified",
    emailVerified = "emailVerified",
    envelopePending = "envelopePending",
    envelopeRead = "envelopeRead",
    envelopeUnread = "envelopeUnread",
    equipmentAlerts = "equipmentAlerts",
    equipmentAlertMessages = "equipmentAlertMessages",
    equipmentAlertUrgent = "equipmentAlertUrgent",
    excel = "excel",
    excelDisabled = "excelDisabled",
    excelFile = "excelFile",
    excludeTender = "excludeTender",
    exit = "exit",
    expand = "expand",
    expireTableRows = "expireTableRows",
    export = "export",
    exportCSV = "exportCSV",
    exportExcel = "exportExcel",
    eyeSee = "eyeSee",
    fan = "fan",
    feasibility = "feasibility",
    fire = "fire",
    folder = "folder",
    form = "form",
    formPencil = "formPencil",
    ftlDryVanOrder = "ftlDryVanOrder",
    ftlDryVanQuote = "ftlDryVanQuote",
    fuelCard = "fuelCard",
    fuelCardActivate = "fuelCardActivate",
    fuelCardBlock = "fuelCardBlock",
    fuelPrice = "fuelPrice",
    funnel = "funnel",
    funnelFilled = "funnelFilled",
    googlePlaces = "googlePlaces",
    hamburger = "hamburger",
    handshake = "handshake",
    heart = "heart",
    hierarchy = "hierarchy",
    highway_icon = "highway_icon",
    highwayEmailVerificationLogo = "highwayEmailVerificationLogo",
    highwayError = "highwayError",
    historyEvents = "historyEvents",
    home = "home",
    import = "import",
    inactiveCircle = "inactiveCircle",
    inboundDFInvoiceError = "inboundDFInvoiceError",
    inboundShipmentStatusError = "inboundShipmentStatusError",
    inboundShipStatus = "inboundShipStatus",
    inboundTender = "inboundTender",
    inboundTenderError = "inboundTenderError",
    inboundTenderWarning = "inboundTenderWarning",
    inFlight = "inFlight",
    intelliroute = "intelliroute",
    intellirouteview = "intellirouteview",
    intercompany = "intercompany",
    intercompanyError = "intercompanyError",
    invite = "invite",
    isoMarkPurple = "isoMarkPurple",
    key = "key",
    keyOff = "keyOff",
    laneHistory = "laneHistory",
    lateRoute = "lateRoute",
    layout = "layout",
    letterCase = "letterCase",
    lightBulb = "lightBulb",
    lightningBolt = "lightningBolt",
    link = "link",
    links = "links",
    list = "list",
    listSearch = "listSearch",
    listStar = "listStar",
    loadAvailable = "loadAvailable",
    loadBoardPostingError = "loadBoardPostingError",
    loadboard = "loadboard",
    loadboardRatesPosted = "loadboardRatesPosted",
    loadboardRefresh = "loadboardRefresh",
    loadCovered = "loadCovered",
    loadDelivery = "loadDelivery",
    loaded = "loaded",
    loadInProgress = "loadInProgress",
    loadMatch = "loadMatch",
    loadPickup = "loadPickup",
    loadVoided = "loadVoided",
    locateMove = "locateMove",
    locateTrailer = "locateTrailer",
    locationToProspect = "locationToProspect",
    lock = "lock",
    lockOpen = "lockOpen",
    ltlPalletOrder = "ltlPalletOrder",
    ltlPalletQuote = "ltlPalletQuote",
    mPact = "mPact",
    magnifyingGlass = "magnifyingGlass",
    magnifyingGlassPage = "magnifyingGlassPage",
    mailMulti = "mailMulti",
    manifest = "manifest",
    mapLocator = "mapLocator",
    mapPinPerson = "mapPinPerson",
    maximize = "maximize",
    messagesConfirm = "messagesConfirm",
    messagesConversation = "messagesConversation",
    messagesFleet = "messagesFleet",
    messagesIncomingFilled = "messagesIncomingFilled",
    messagesIncomingOutlined = "messagesIncomingOutlined",
    messagesOutgoingFilled = "messagesOutgoingFilled",
    messagesOutgoingOutlined = "messagesOutgoingOutlined",
    messagesReply = "messagesReply",
    minimize = "minimize",
    mobileCommChats = "mobileCommChats",
    money = "money",
    moneyInHand = "moneyInHand",
    monitoringService = "monitoringService",
    mpactLogoDark = "mpactLogoDark",
    multiMoves = "multiMoves",
    multipleRecords = "multipleRecords",
    multipleSelected = "multipleSelected",
    noPencil = "noPencil",
    noRecord = "noRecord",
    notes = "notes",
    notification = "notification",
    notificationCount = "notificationCount",
    notLoaded = "notLoaded",
    number = "number",
    offered = "offered",
    offerHistory = "offerHistory",
    offerLog = "offerLog",
    onHold = "onHold",
    oneToMany = "oneToMany",
    oneToOne = "oneToOne",
    openapi = "openapi",
    orderHistory = "orderHistory",
    orderHistoryWithAlerts = "orderHistoryWithAlerts",
    orderLinked = "orderLinked",
    outboundDFInvoiceError = "outboundDFInvoiceError",
    outboundInvoiceStatus = "outboundInvoiceStatus",
    outboundShipmentStatusError = "outboundShipmentStatusError",
    outboundShipStatus = "outboundShipStatus",
    outboundTender = "outboundTender",
    outboundTenderError = "outboundTenderError",
    overlappingWindows = "overlappingWindows",
    package = "package",
    packageDrop = "packageDrop",
    packageError = "packageError",
    payAdjustment = "payAdjustment",
    payablesContact = "payablesContact",
    payee = "payee",
    pdf = "pdf",
    pdfDisabled = "pdfDisabled",
    pdfFile = "pdfFile",
    pencil = "pencil",
    pendingCashReceipt = "pendingCashReceipt",
    people = "people",
    person = "person",
    personSolid = "personSolid",
    phone = "phone",
    pickup = "pickup",
    pictureOutlined = "pictureOutlined",
    pinArrow = "pinArrow",
    pinOutlined = "pinOutlined",
    pointer = "pointer",
    pop = "pop",
    popout = "popout",
    postman = "postman",
    print = "print",
    printed = "printed",
    processLog = "processLog",
    profileFilter = "profileFilter",
    profileFiltered = "profileFiltered",
    purposeSwap = "purposeSwap",
    pushPin = "pushPin",
    quickPay = "quickPay",
    quickQuote = "quickQuote",
    quoteExpirationActive = "quoteExpirationActive",
    quoteExpirationSet = "quoteExpirationSet",
    radioOff = "radioOff",
    radioOn = "radioOn",
    raml = "raml",
    rateConExpired = "rateConExpired",
    rateConResent = "rateConResent",
    rateThisOrder = "rateThisOrder",
    rawData = "rawData",
    readyToPrint = "readyToPrint",
    readyToSubmit = "readyToSubmit",
    rebill = "rebill",
    reconsignment = "reconsignment",
    recurringMessage = "recurringMessage",
    recurringSchedule = "recurringSchedule",
    redo = "redo",
    reeferStatus = "reeferStatus",
    reeferStatusError = "reeferStatusError",
    reeferStatusWarn = "reeferStatusWarn",
    refresh = "refresh",
    reload = "reload",
    removeHold = "removeHold",
    reorder = "reorder",
    report = "report",
    reprintFreightBill = "reprintFreightBill",
    replyArrowFilled = "replyArrowFilled",
    resendMessage = "resendMessage",
    resubmit = "resubmit",
    reticle = "reticle",
    restoreWindow = "restoreWindow",
    ribbon = "ribbon",
    ribbonAlert = "ribbonAlert",
    ribbonCheck = "ribbonCheck",
    ribbonWarning = "ribbonWarning",
    rocketShip = "rocketShip",
    run = "run",
    searchOrders = "searchOrders",
    seated = "seated",
    selectAll = "selectAll",
    send = "send",
    seriousBadge = "seriousBadge",
    settings = "settings",
    settlementHold = "settlementHold",
    settlementProcess = "settlementProcess",
    settlementRecord = "settlementRecord",
    settlements = "settlements",
    share = "share",
    shellManifest = "shellManifest",
    shipmentLocation = "shipmentLocation",
    showTransmissionLog = "showTransmissionLog",
    shrink = "shrink",
    sideBySide = "sideBySide",
    sortingOff = "sortingOff",
    spinner = "spinner",
    splitBill = "splitBill",
    splitViewHorizontal = "splitViewHorizontal",
    splitViewTimeline = "splitViewTimeline",
    splitViewVertical = "splitViewVertical",
    spotOrder = "spotOrder",
    star = "star",
    steeringWheel = "steeringWheel",
    suggestedPricing = "suggestedPricing",
    summaryInvoice = "summaryInvoice",
    swagger = "swagger",
    tab = "tab",
    tenderCounter = "tenderCounter",
    tenderDecline = "tenderDecline",
    tenders = "tenders",
    terminalInfo = "terminalInfo",
    textSearch = "textSearch",
    thread = "thread",
    threePeople = "threePeople",
    threePeopleBlueMiddle = "threePeopleBlueMiddle",
    timeExpired = "timeExpired",
    timeWarning15 = "timeWarning15",
    timeWarning30 = "timeWarning30",
    timeWarning60 = "timeWarning60",
    topMatch = "topMatch",
    trackingLate = "trackingLate",
    trackingPlaceholder = "trackingPlaceholder",
    tractorAdd = "tractorAdd",
    trailer = "trailer",
    trailerPoolIdle10 = "trailerPoolIdle10",
    trailerPoolIdle30 = "trailerPoolIdle30",
    trailerPoolRadius = "trailerPoolRadius",
    transferredToSettlements = "transferredToSettlements",
    triangleWarning = "triangleWarning",
    triangleWarningSolid = "triangleWarningSolid",
    truck = "truck",
    truckstopLogo = "truckstopLogo",
    triumphPayIcon="triumphPayIcon",
    unavailable = "unavailable",
    unbilled = "unbilled",
    unbilledOrders = "unbilledOrders",
    undo = "undo",
    unlinked = "unlinked",
    unReadMessageIcon = "unReadMessageIcon",
    unseated = "unseated",
    vendorTrackingIcon = "vendorTrackingIcon",
    versionLog = "versionLog",
    viaPoint = "viaPoint",
    viewMovements = "viewMovements",
    viewProperties = "viewProperties",
    viewRecovery = "viewRecovery",
    visibilityOff = "visibilityOff",
    visibilityOn = "visibilityOn",
    warningBadge = "warningBadge",
    waterfall = "waterfall",
    wireAdvances = "wireAdvances",
    wizard = "wizard",
    wrench = "wrench",
    wsdl = "wsdl",
    x = "x",
    ysplit = "ysplit",
    ysplitComplete = "ysplitComplete",
    ysplitOpen = "ysplitOpen",
    ysplitPick = "ysplitPick",
    zipCode = "zipCode",
    zMit = "zMit",
    zMitNotTransmitted = "zMitNotTransmitted",
    zMitTransmitted = "zMitTransmitted",
    zMitTransmittedAccepted = "zMitTransmittedAccepted",
    zMitTransmittedRejected = "zMitTransmittedRejected",
    info = "info"
}
